<template>
    <v-form @submit.prevent="updateMembership" ref="form">
        <v-card dense class="rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">{{ mode }} Team Membership</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support. Error details: {{ errorMessage }}
            </v-alert> 
            <v-card-text>
                <v-layout row wrap class="form-data">  
                    <v-flex xs12 sm6 :class="isMobile?'':'form-row-left-mobile'">
                        <v-autocomplete
                            label="Team"
                            v-model="teamId"
                            :disabled="disabled||isEditMode"
                            :items="teams"
                            :loading="loading_teams"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            item-text="name"
                            item-value="teamId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 :class="isMobile?'':'form-row-right-mobile'"> 
                        <v-autocomplete
                            label="Role"
                            v-model="roleId"
                            :disabled="disabled"
                            :items="roles"
                            :loading="loading_roles"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            item-text="name"
                            item-value="teamRoleId"
                            persistent-hint
                            :hint="roleDescrition"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="form-data" style="margin-top:20px;"> 
                    <v-flex xs12 sm6 :class="isMobile?'':'form-row-left-mobile'">
                        <v-autocomplete
                            v-model="supervisorId"
                            :disabled="disabled"
                            :items="approvers"
                            :loading="loading_approvers"
                            :rules="[rules.required]"
                            box
                            chips
                            color="primary lighten-2"
                            label="Immediate Supervisor"
                            item-text="name"
                            item-value="supervisorId"
                            >
                            <template v-slot:selection="data">
                                <v-chip
                                    :selected="data.selected"
                                    class="chip--select-multi"
                                    >
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 :class="isMobile?'':'form-row-right-mobile'">
                        <v-switch
                            v-model="visibleInMyTeams"
                            label="Show Employee in My Teams"
                            color="primary"
                            persistent-hint
                            :hint="visibleInMyTeams
                                ? 'Employee will be shown on the My Teams main page. Team Role visibility overrides this setting.'
                                : 'Employee will not be shown on the My Teams main page.'"
                            ></v-switch>  
                    </v-flex>
                </v-layout>
            </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="isAddMode" @click="clearForm">Clear</v-btn>
            <v-btn color="primary" type="submit" :loading="loading" class="mr-25">Save</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import teamApi from '@/api/team'
import employeeApi from '@/api/employees'
import teamRolesApi from '@/api/teamroles'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    name: 'dialog',
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,       
            rules: {
                required: value => !!value || 'Required.'
            },
            error: false,
            errorMessage: '',
            userId: null,
            teamId: null,
            roleId: null,
            supervisorId: '',
            visibleInMyTeams: false,
            loading_teams: false,
            loading_approvers: false,
            loading_roles: false,
            teams: [],
            teams_all: [],
            existing_membership: [],
            approvers: [],
            roles: [],
            mode: null
        }
    },
    methods: {
        closeDialog() {
            this.$emit('update:dialogUpdateTeamMembership', false)
            this.clearForm()
        },
        async setParams(data) {
            if (!this.teams_all.length) {
                await this.getTeams()
            }
            if (!this.roles.length) {
                await this.getRoles()
            }
            if (this.approvers.length == 0) {
                await this.getApprovers()
            }
            this.existing_membership = data.membership
            this.mode = data.mode
            this.userId = data.userId
            if (data.mode == 'Update') {
                this.teamId = data.teamId
                this.roleId = data.roleId        
                this.supervisorId = data.supervisorId 
                this.visibleInMyTeams = data.visibleInMyTeams               
            }else{                
                this.clearForm()
            }
            this.filterTeams()
        },
        filterTeams() {
            this.teams = this.teams_all

            //exclude those already exist
            if (this.existing_membership && this.existing_membership.length) {
                this.teams = this.teams_all.filter(t => {
                    return !this.existing_membership.some(x => x.teamId == t.teamId) 
                });
            }
        },
        async getApprovers() {
            try {
                this.loading_approvers = true
                this.approvers = []
                const response = await employeeApi.getAll()
                if (response && response.status == 200) {
                    const members = response.data.employees
                    members.forEach(item => {
                        this.approvers.push({
                            supervisorId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            group: item.team
                        })
                    })
                }
                this.loading_approvers = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async getTeams() {
            try {
                this.loading_teams = true
                const response = await teamApi.getTeamsByCompany(false)
                if (response && response.status == 200) {
                    this.teams = response.data.items
                    this.teams_all = response.data.items
                }
                this.loading_teams = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async getRoles() {
            try {
                this.loading_roles = true
                const response = await teamRolesApi.getRoles()
                if (response && response.status == 200) {
                    this.roles = response.data.items
                }
                this.loading_roles = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async updateMembership() {
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    const data = {
                        userId: this.userId,
                        roleId: this.roleId,
                        teamId: this.teamId,
                        supervisorId: this.supervisorId,
                        visibleInMyTeams: this.visibleInMyTeams
                    }
                    const response = await teamApi.upsertMembership(data)
                    if (response && response.status == 200) {
                        this.$emit('send',null)
                        this.clearForm()
                        this.closeDialog()
                    }
                    this.loading = false
                    this.disabled = false
                }catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },     
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
    computed: {
        isEditMode() {
            return this.mode == 'Update'
        },
        isAddMode() {
            return this.mode == 'Add'
        },
        roleDescrition() {
            if (this.roles.length) {
                if (!this.roleId) return ''
                return this.roles.filter(x => x.teamRoleId == this.roleId)[0].description
            }
        }
    },
    created() {}
}
</script>
<style scoped>
.form-data {
    margin: 0px 20px 0px 20px;
}
.form-row-left-mobile {
    padding-right:15px;
}
.form-row-right-mobile {
    padding-left:15px;
}
</style>